import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/EditNotification.css';
import api from '../utils/axiosConfig';

const EditNotificationUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    userCode: '',
    sessionName: 'session09',
    startDate: null,
    singleTime: null,
    isRecurring: false
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await api.get(`/api/notifications/${id}`);
        const notification = response.data.notification;
        
        const scheduledDate = new Date(notification.scheduledAt);
        
        setFormData({
          userCode: notification.userCode,
          sessionName: notification.sessionName || 'session09',
          startDate: scheduledDate,
          singleTime: scheduledDate,
          isRecurring: false // Default to single notification for editing
        });
        
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch notification');
        setLoading(false);
      }
    };

    fetchNotification();
  }, [id]);

  const handleDateChange = (date, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: date
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    try {
      // Combine date and time for single notification
      const scheduledAt = new Date(formData.startDate);
      if (formData.singleTime) {
        scheduledAt.setHours(formData.singleTime.getHours());
        scheduledAt.setMinutes(formData.singleTime.getMinutes());
      }

      // Check for weekends
      if (scheduledAt.getDay() === 0 || scheduledAt.getDay() === 6) {
        throw new Error('Benachrichtigungen können nicht am Wochenende erstellt werden');
      }
      await api.put(`/api/notifications/${id}`, {
        userCode: formData.userCode,
        sessionName: formData.sessionName,
        scheduledAt: scheduledAt.toISOString()
      });
      
      setSuccess(true);
      setTimeout(() => navigate('/my-notifications'), 1500);
    } catch (err) {
      setError(err.message || err.response?.data?.error || 'Fehler beim Aktualisieren der Benachrichtigung');
    }
  };

  if (loading) return <div className="loading">Lade Benachrichtigung...</div>;

  return (
    <div className="edit-notification-container">
      <h1>Zeitplan bearbeiten</h1>
      
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">Benachrichtigung erfolgreich aktualisiert!</div>}

      <form onSubmit={handleSubmit} className="edit-notification-form">
        {/* Read-only user code field */}
        <div className="form-group">
          <label>Teilnehmer Code</label>
          <input
            type="text"
            value={formData.userCode}
            readOnly
            className="read-only-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="sessionName">
            Session Name
          </label>
          <input
            type="text"
            id="sessionName"
            name="sessionName"
            value={formData.sessionName}
            onChange={handleChange}
            required
            readOnly
            className="read-only-input"
          />
        </div>

        {/* Date and time pickers */}
        <div className="form-group">
          <label>Datum</label>
          <DatePicker
            selected={formData.startDate}
            onChange={(date) => handleDateChange(date, 'startDate')}
            minDate={new Date()}
            excludeDates={[0, 6]} // Exclude weekends
            dateFormat="dd.MM.yyyy"
            placeholderText="Datum wählen"
            className="date-input"
            required
          />
        </div>

        <div className="form-group">
          <label>Uhrzeit (24h Format)</label>
          <DatePicker
            selected={formData.singleTime}
            onChange={(time) => handleDateChange(time, 'singleTime')}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={10}
            timeCaption="Uhrzeit"
            dateFormat="HH:mm"
            timeFormat="HH:mm"
            placeholderText="Uhrzeit wählen (z.B. 14:30)"
            className="time-input"
            required
          />
        </div>

        <div className="button-group">
          <button type="submit" className="submit-button">
            Änderungen speichern
          </button>
          <button 
            type="button" 
            className="cancel-button"
            onClick={() => navigate('/my-notifications')}
          >
            Abbrechen
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditNotificationUser;